import spinnerImgPurple from "@assets/images/sand-glass-purple.svg";
import spinnerImgGreen from "@assets/images/sand-glass.svg";
import { Paper } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
const useStyles = makeStyles(
  theme => ({
    root: {
      width: "560px",
      padding: "48px 24px 46px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      margin: "0 auto",
      borderRadius: "1.6rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
    },
    caption: {
      color: theme.palette.grey[900],
      marginBottom: "1.2rem"
    },
    spinnerContainer: {
      position: "relative",
      margin: "0 0 80px"
    },
    spinnerGreen: {
      position: "absolute",
      animation: `$spin 0.9s ease-in-out infinite alternate`
    },
    "@keyframes spin": {
      "0%": { transform: "rotate(0deg)" },
      "20%": { transform: "rotate(0deg)" },
      "80%": { transform: "rotate(180deg)" },
      "100%": { transform: "rotate(180deg)" }
    },
    spinnerPurple: {
      position: "absolute",
      animation: `$spinFade 0.9s ease-in-out infinite alternate`
    },
    "@keyframes spinFade": {
      "0%": { transform: "rotate(180deg)", opacity: 0 },
      "20%": { transform: "rotate(180deg)", opacity: 0 },
      "80%": { transform: "rotate(360deg)", opacity: 1 },
      "100%": { transform: "rotate(360deg)", opacity: 1 }
    }
  }),
  { name: "SubmitOrder" }
);

const SubmitOrder: React.FC<any> = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <div className={classes.spinnerContainer}>
        <img
          src={spinnerImgGreen}
          className={classes.spinnerGreen}
          alt="spinner-green"
        />
        <img
          src={spinnerImgPurple}
          className={classes.spinnerPurple}
          alt="spinner-purple"
        />
      </div>
      <MyTypography variant="h6" className={classes.caption}>
        The system is processing orders...
      </MyTypography>
      <MyTypography variant="body2">
        ระบบกำลังประมวลผลคำสั่งซื้อ กรุณารอสักครู่
      </MyTypography>
    </Paper>
  );
};

export default SubmitOrder;
